<template>
  <div class="resource">
    <div class="sift">
      <div class="title">操作日志查询</div>
      <div class="inquire">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" size="small">
          <el-form-item>
            <strong slot="label">请求参数</strong>
            <el-input
              v-model="formInline.operParam"
              placeholder="请输入请求参数"
              clearable
              @keyup.enter.native="inquire"
              @clear="inquire"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <strong slot="label">操作时间</strong>
            <el-date-picker
              v-model="formInline.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="inquire" style="background:#0C75E5">查询</el-button>
            <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="detail">
      <div class="title">操作日志列表</div>
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
      >
        <el-table-column prop="title" label="操作模块" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operName" label="操作人员" width="120"></el-table-column>
        <el-table-column prop="operIp" label="操作IP" width="140"></el-table-column>
        <el-table-column prop="requestMethod" label="请求方式" width="110"></el-table-column>
        <el-table-column prop="operParam" label="请求参数" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.status === 0 ? 'success' : 'danger'">
              {{ scope.row.status === 0 ? '正常' : '异常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="errorMsg" label="错误消息" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作时间" width="170">
          <template slot-scope="scope">
            {{ scope.row.operTime | filter_handleDateTime }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 10, 20, 30, 40]"
        :page-size="pageSize"
        layout="->, total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import url from '@/config/url'

export default {
  data() {
    return {
      formInline: {
        operParam: '',
        dateRange: []
      },
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: true
    }
  },
  created() {
    this.getList()
  },
  methods: {
    inquire() {
      this.pageNum = 1
      this.loading = true
      this.getList()
    },
    reset() {
      this.formInline.operParam = ''
      this.formInline.dateRange = []
      this.pageNum = 1
      this.loading = true
      this.getList()
    },
    getList() {
      const beginTime = this.formInline.dateRange && this.formInline.dateRange.length ? this.formInline.dateRange[0] : ''
      const endTime = this.formInline.dateRange && this.formInline.dateRange.length ? this.formInline.dateRange[1] : ''
      this.$http.get(url.getOperLogList, {
        params: {
          operParam: this.formInline.operParam,
          beginTime,
          endTime,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.loading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.list || []
          this.total = res.data.data.total || 0
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.loading = true
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.loading = true
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">
</style>
